import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseURL } from '../utils/convertParams';
import ConnectBank from '../components/connectBank/index.jsx';
import Deposit from '../components/deposit/index.jsx';
import {
  DESKTOP,
  MOBILE,
  isMobileDevice,
  isPlaidSDKShowing,
  redirectToUrl,
  setPlaidIframeDefaultSize,
  setPlaidIframeResize,
  replaceEvent,
  isIbtReturnUrl,
} from '../utils/common';
import { VerifyBankBodyWrapper } from '../components/deposit/styled.jsx';
import * as AppActions from '../stores/app/actions';
import { Footer } from 'react-components-core';
import styled from '@emotion/styled';
import {convertMetaDataExit} from "../utils/convertData";
import {
  getTransactionInfo, removeTransactionInfoAndAuthToken,
  setLanguageInSessionStorage
} from '../utils/sessionStorage';
import { useNavigate } from "react-router-dom";
import { useMappingErrorMessage } from "../hooks/useMappingErrorMessage";
import { defaultTheme } from '../globalStyleds.js';

export const BodyBankSelectionStyled= styled.div`
 height: calc(100vh - 65px);
`;

const hideBodyBank = { overflow: 'hidden', height: 0 };

export const VerifyBank = () => {
  const dispatch = useDispatch();
  const transactionInfo = getTransactionInfo();
  const appStore = useSelector((state) => state).app;
  const [connectBankComplete, setConnectBankComplete] = useState(false);
  const [isLoadingFinish, setStatusLoadingFinish] = useState(false);
  const [isIframeResize, setIsIframeResize] = useState(false);
  const [isMobile, setIsMobile] = useState(isMobileDevice());
  const isExistPlaid = isPlaidSDKShowing();
  const error = useMappingErrorMessage()

  const { isConfirm, isBackMerchant, isExitSuccess, obvInfo, isVerification, hidePlaidFooter } = appStore;
  const { skipTransResultPage } = obvInfo;
  const { params } = parseURL(window.location.href);
  const { code, oauth_state_id: oauthStateId, merchant_return_url: merchantReturnUrl, merchant_app_return_url: merchantAppReturnUrl, theme: theme } = params;
  let navigate = useNavigate();

  const onSuccess = () => {
    setConnectBankComplete(true);
  };

  useEffect(() => {
    const body = window.document.getElementById('body-main');
    const themeName = theme || defaultTheme;
    let bodyClass = isMobile ? MOBILE : DESKTOP;
    if (body.classList.contains(DESKTOP)) {
      body.classList.replace(DESKTOP, bodyClass);
    } else if (body.classList.contains(MOBILE)) {
      body.classList.replace(MOBILE, bodyClass);
    } else {
      body.classList.add(bodyClass);
    }
    body.classList.add(themeName);
  }, [isMobile, theme]);

  useEffect(() => {
    if (obvInfo && !obvInfo.properties && transactionInfo && transactionInfo.properties) {
      dispatch(AppActions.addProperties(transactionInfo.properties));
    }

    if (obvInfo && obvInfo.properties) {
      setIsIframeResize(obvInfo.properties.isIframeResize);
      setIsMobile(obvInfo.properties.isEmbeddedUI || isMobile);
    } else if (transactionInfo && transactionInfo.properties) {
      setIsIframeResize(transactionInfo.properties.isIframeResize);
      setIsMobile(transactionInfo.properties.isEmbeddedUI || isMobile);
    }
  }, [obvInfo, isMobile, transactionInfo, dispatch]);

  useEffect(() => {
    if (isExistPlaid) {
      if (isIframeResize) {
        setPlaidIframeResize();
      } else {
        setPlaidIframeDefaultSize();
      }
    }
  }, [isIframeResize, isExistPlaid]);

  useEffect(() => {
    if (params.language) {
      setLanguageInSessionStorage(params.language);
    }
  }, []);

  const merchantUrl = useMemo(() => {
    return transactionInfo?.merchantReturnUrl || merchantAppReturnUrl || merchantReturnUrl;
  }, [transactionInfo, merchantAppReturnUrl, merchantReturnUrl]);

  const handleOnClose = useCallback(() => {
    dispatch(AppActions.exitEvent(convertMetaDataExit(transactionInfo)));
  }, [dispatch, transactionInfo]);

  const backToMerchant = useCallback(() => {
    dispatch(AppActions.backMerchant());
  }, [dispatch]);

  useEffect(() => {
    if(isBackMerchant) {
      removeTransactionInfoAndAuthToken();
      const isCancel = (isExitSuccess === true || isExitSuccess === 'true');
      if (isIbtReturnUrl(merchantUrl)) {
        let newUrl;
        if (error?.status || error?.message) {
          newUrl = replaceEvent(merchantUrl, 'getAccountBalance', 'obvReauthFailed');
        } else if (isCancel) {
          newUrl = replaceEvent(merchantUrl, 'getAccountBalance', 'doCancel');
        } else {
          newUrl = merchantUrl;
        }
        redirectToUrl(newUrl);
      } else if (skipTransResultPage) {
        redirectToUrl(merchantUrl);
      } else {
        const params = {
          "redirectUrl": merchantUrl,
          "isSuccess": isConfirm === true || isConfirm === 'true',
          isCancel
        };
        navigate(`/safe-to-close?${new URLSearchParams(params).toString()}`);
      }
    }
  }, [dispatch, isBackMerchant, merchantUrl, skipTransResultPage, isConfirm, isExitSuccess, navigate, error])

  const renderIntegration = () => {
    return (
      <VerifyBankBodyWrapper>
        <ConnectBank
          onClickBack={backToMerchant}
          onClickClose={handleOnClose}
          code={code}
          afterOnSuccess={onSuccess}
          merchantReturnUrl={merchantUrl}
          theme={theme}
          oauthPresent={oauthStateId}
          isMobile={isMobile}
          isResize={isIframeResize}
          setStatusLoadingFinish={setStatusLoadingFinish}
        ></ConnectBank>
      </VerifyBankBodyWrapper>
    );
  };

  const renderConfirmation = () => {
    return <Deposit
      error={error}
      isMobile={isMobile}
      isConfirm={isConfirm}
      obvInfo={obvInfo}
      onClickBack={backToMerchant}
      onClickClose={handleOnClose}
    />;
  };

  const renderFooter = () => {
    if(!isMobile && error?.message && (isVerification || isLoadingFinish)) {
      return null;
    } else if(isMobile && hidePlaidFooter && !connectBankComplete) {
      return null;
    }
    return <Footer integration='plaidNuvei'></Footer>
  }

  return <div className='VerifyBank'>
    <BodyBankSelectionStyled style={ isExistPlaid && isMobile ? hideBodyBank : {}}>
      {
        connectBankComplete && isLoadingFinish ? renderConfirmation() : renderIntegration()
      }
    </BodyBankSelectionStyled>

    { isLoadingFinish && renderFooter() }
  </div>;
};

VerifyBank.propTypes = {};


export default VerifyBank;
